/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Menu from "../../assets/icons/menu.svg";
import Madkpi from "../../assets/icons/MAD_KPI_LOGO_FINAL.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useDataContext } from "../Context/context";
import useToast from "../Hooks/Toast";
import Cookies from "js-cookie";
import money from "../../assets/icons/money (1) 1.png";
import dashboard from "../../assets/icons/dashboard.png";
import settings from "../../assets/icons/settings (2) 1.png";
import group from "../../assets/icons/group 1.png";
import logoutImg from "../../assets/icons/Logout_Icon.png";
import { cookieGetter } from "../utils/HelperFunction";
import { MdOutlineArchive, MdUnarchive } from "react-icons/md";

const Header = () => {
  const role = cookieGetter("role");

  const { toSetLogin } = useDataContext();
  const [toggle, setToggle] = useState(false);
  const Navigate = useNavigate();
  const [userAccess, setUserAccess] = useState(false);
  const [admin, setAdmin] = useState(false);
  const notify = useToast();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [showBudgetDropdown, setShowBudgetDropdown] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const archivedParam = queryParams.get("archived");

  const [selectedDropdown, setSelectedDropdown] = useState(() => {
    if (archivedParam === "true") return "true";
    if (archivedParam === "false") return "false";
    return "all";
  });

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    const visible = prevScrollPos > currentScrollPos;
    setPrevScrollPos(currentScrollPos);
    setVisible(visible);
  };

  // Add scroll event listener when component mounts
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  const handleBudgetNavigation = (archivedParam) => {
    setSelectedDropdown(archivedParam);
    if (archivedParam === 'all') {
      Navigate('/budget');
    } else {
      Navigate(`/budget?archived=${archivedParam}`);
    }
  };

  useEffect(() => {
    if (role === "EDITOR") {
      setUserAccess(true);
      notify(`You don't have permission to access this page`, "error");
    } else if (role === "ADMIN") {
      setAdmin(true);
    }
  }, [role]);

  const logout = () => {
    Cookies.remove("appIdToken");
    toSetLogin();
    Navigate("/login");
  };

  const isActive = (path) => (location.pathname === path ? "active-link" : "");
  const isSelected = (value) =>
    selectedDropdown === value
      ? "bg-blue-50 font-medium text-primaryColor"
      : "text-gray-800";

  return (
    <>
      {
        <div className={visible ? "header" : "hide"}>
          <h1 className="m-0">
            <a href="/home">
              <img className="max-w-[141px] ml-6 h-[70%]" src={Madkpi} alt="" />
            </a>
          </h1>
          <div className="max-lg:hidden lg:flex lg:gap-5 xl:gap-12 w-[85%]  justify-end items-center lg:mr-2 xl:mr-5">
            <button
              onClick={() => Navigate("/dashboard")}
              className={`flex items-center text-primaryColor text-xs xl:text-sm 2xl:text-lg font-medium hover:underline  ${isActive(
                "/dashboard"
              )}`}
            >
              <img
                src={dashboard}
                alt="Budget Icon"
                className="mr-1 xl:mr-1.5 h-[23px] w-[23px]"
              />
              Dashboard
            </button>
            {/* Budget Management with Dropdown */}
            <div
              className="relative group"
              onMouseEnter={() => setShowBudgetDropdown(true)}
              onMouseLeave={() => setShowBudgetDropdown(false)}
            >
              <button
                onClick={() => handleBudgetNavigation("all")}
                className={`flex items-center text-primaryColor text-xs xl:text-sm 2xl:text-lg font-medium hover:underline ${isActive("/budget")}`}
              >
                <img
                  src={money}
                  alt="Budget Icon"
                  className="mr-1 xl:mr-1 h-[23px] w-[23px]"
                />
                Budget - Management
              </button>

              {/* Dropdown */}
              {showBudgetDropdown && (

                <div className="absolute flex flex-col items-start z-50 bg-white border border-gray-200 rounded-lg shadow-xl py-2 px-3 w-56">
                  <button
                    onClick={() => handleBudgetNavigation("false")}
                    className={`flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 rounded-md text-sm transition-colors ${isSelected("false")}`}
                  >
                    <MdUnarchive className="text-green-600" />
                    <span>Active</span>
                  </button>
                  <button
                    onClick={() => handleBudgetNavigation("true")}
                    className={`flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-100 rounded-md text-sm transition-colors ${isSelected("true")}`}
                  >
                    <MdOutlineArchive className="text-red-500" />
                    <span>Archived</span>
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={() => Navigate("/home")}
              className={`flex items-center text-primaryColor text-xs xl:text-sm 2xl:text-lg font-medium hover:underline  ${isActive(
                "/home"
              )}`}
            >
              <span>
                <img
                  src={settings}
                  alt="Configurations Icon"
                  className="mr-1 xl:mr-1 h-[23px] w-[23px]"
                />
              </span>
              Configurations
            </button>
            <button
              onClick={() => Navigate("/user")}
              className={`flex items-center text-primaryColor text-xs xl:text-sm 2xl:text-lg font-medium hover:underline  ${isActive(
                "/user"
              )}`}
            >
              <span className="">
                <img
                  src={group}
                  alt="User Management Icon"
                  className="mr-1 xl:mr-1 h-[23px] w-[23px]"
                />
              </span>
              User - Management
            </button>
            <button
              onClick={() => logout()}
              className="flex items-center px-3 py-1.5 text-xs xl:text-sm 2xl:text-lg font-medium rounded-[7px] text-white bg-primaryColor border border-primaryColor hover:text-primaryColor hover:bg-white user"
            >
              <img src={logoutImg} alt="Budget Icon" className="mr-2" />
              Logout
            </button>
          </div>

          <div className="mobilemenu">
            <a href="#" onClick={() => setToggle(!toggle)}>
              <img className="menu" src={Menu} alt="" />
            </a>
          </div>
        </div>
      }
      <ToastContainer />
      {toggle && (
        <div className="sidebar w-[30dvw]">
          <div className="flex justify-space">
            <div className="flex flex-col justify-start items-start gap-4">
              <button
                onClick={() => Navigate("/dashboard")}
                className={` text-primaryColor flex items-center text-lg font-medium ${isActive(
                  "/dashboard"
                )}`}
              >
                <img
                  src={dashboard}
                  alt="Budget Icon"
                  className="mr-2 xl:mr-2.5 h-9 w-9"
                />
                Dashboard
              </button>
              <button
                onClick={() => Navigate("/budget")}
                className={` text-primaryColor flex items-center justify-center text-lg  font-medium ${isActive(
                  "/budget"
                )}`}
              >
                <img src={money} alt="Budget Icon" className="mr-2" />
                Budget - Management
              </button>

              <button
                onClick={() => Navigate("/home")}
                className={` text-primaryColor flex items-center justify-center text-lg  font-medium ${isActive(
                  "/home"
                )}`}
              >
                <span>
                  <img
                    src={settings}
                    alt="Configurations Icon"
                    className="mr-2"
                  />
                </span>
                Configurations
              </button>

              {/* <button onClick={() => Navigate("/category")}>Create Category</button> */}

              <button
                onClick={() => Navigate("/user")}
                className={` text-primaryColor flex items-center justify-center text-lg  font-medium ${isActive(
                  "/user"
                )}`}
              >
                <span className="">
                  <img
                    src={group}
                    alt="User Management Icon"
                    className="mr-2"
                  />
                </span>
                User - Management
              </button>
            </div>
            <button
              onClick={() => logout()}
              className="font-normal px-5 py-2 mt-3 rounded-[7px] text-white flex justify-center items-center bg-primaryColor border border-primaryColor hover:text-primaryColor hover:bg-white user"
            >
              <img src={logoutImg} alt="Budget Icon" className="mr-2" />
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default Header;
